import { toast, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const defaultNotify = (text: string) =>
  toast(text, {
    position: 'top-right',
    hideProgressBar: true,
    className: 'bg-primary text-white',
    transition: Slide,
  })
export const successNotify = (text: string) =>
  toast(text, {
    position: 'top-center',
    hideProgressBar: true,
    closeOnClick: false,
    className: 'bg-success text-white',
    transition: Slide,
  })
export const warningNotify = (text: string) =>
  toast(text, {
    position: 'top-center',
    hideProgressBar: true,
    closeOnClick: false,
    className: 'bg-warning text-white',
    transition: Slide,
  })
export const errorNotify = (text: string) =>
  toast(text, {
    position: 'top-center',
    hideProgressBar: true,
    closeOnClick: false,
    className: 'bg-danger text-white',
    transition: Slide,
  })
